module.exports = __webpack_public_path__ + "img/learning.6ece41f1.jpg";